import { ALIGN_TYPES, VALUE_TYPES as THVT } from "../../../configs/TableHeaderConstants";
import VALUE_TYPES from "../../../configs/ValueTypeConstants";
import * as Yup from 'yup';

export const CREDIT_NOTE_TABLE_HEADS = [
    { id: 'cn_number', label: 'CN Number', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER },
    { id: 'credit_note_date', label: 'CN Date', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.DATE },
    { id: 'credit_ledger_name', label: 'Account Name (Credit)', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT },
    { id: 'credit_amount', label: 'Credit Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER },
    { id: 'edit', label: 'Edit', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.EDIT },
]

export const CREDIT_NOTE_STATE = {
    credit_note_date: null,
    credit_ledger_id: null,
    credit_amount: 0,
    address: null
};

export const CREDIT_NOTE_SCHEMA = Yup.object().shape({
    credit_note_date: Yup.date().required(),
    credit_ledger_id: Yup.number().required(),
    credit_amount: Yup.number().nullable(),
    address: Yup.string().nullable()
});

export const CREDIT_NOTE_FORM_FIELDS = [
    { name: "cn_number", title: "CN Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "credit_note_date", title: "CN Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "credit_ledger_id", title: "Account Name (Credit)", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "credit_amount", title: "Credit Amount (AED)", required: false, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "address", title: "Address", required: false, type: VALUE_TYPES.TEXT },
];

export const CREDIT_NOTE_LINE_TABLE_HEADS = [
    { id: 'debit_ledger_code', label: 'A/c Code *', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER, width: 150 },
    { id: 'debit_ledger_name', label: 'Account Name (Debit) *', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.TEXT, width: 250 },
    { id: 'particulars', label: 'Particulars *', align: ALIGN_TYPES.ALIGN_LEFT, type: THVT.NUMBER, width: 400 },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: THVT.NUMBER, width: 150 },
    { id: 'icon_btns', label: 'Edit / Delete', align: ALIGN_TYPES.ALIGN_CENTER, type: THVT.ICONBTNS, buttons: ["edit", "delete"] },
]

export const CREDIT_NOTE_LINE_STATE = {
    debit_ledger_id: null,
    particulars: null,
    amount: null,
};

export const CREDIT_NOTE_LINE_SCHEMA = Yup.object().shape({
    debit_ledger_id: Yup.number().required(),
    particulars: Yup.string().required(),
    amount: Yup.number().required()
});

export const CREDIT_NOTE_LINE_FORM_FIELDS = [
    { name: "debit_ledger_id", title: "A/c Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", colSpan: 2 },
    // { name: "debit_ledger_id", title: "Account Name (Debit)", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "particulars", title: "Particulars", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "amount", title: "Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: false },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];


const filterState = {
    accounts: null,
    from_date: null,
    to_date: null
};
const filterSchema = Yup.object().shape({
    accounts: Yup.array().nullable(),
    from_date: Yup.date().nullable(),
    to_date: Yup.date().nullable(),
});

const filterFormFields = [
    { name: "accounts", title: "Accounts", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "from_date", title: "From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "to_date", title: "To Date", required: false, type: VALUE_TYPES.DATEPICKER },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}
